export const environment = {
  production: false,
  userPoolId: "eu-west-1_WvN1oywLC",
  clientId: "vj9aai89r6ikaq27ndh0m1epv",
  gitURL: "https://api.bitbucket.org/2.0/repositories",
  docKibanaURL: "https://www.mapfretabs.com/fwmovilidad/herramientas-de-monitorizacion-y-logs/",
  helpDrawBaaS: "https://www.mapfretabs.com/fwmovilidad/guia-de-usuario/",
  versionPlat: "0.8.0"
};
